import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {Funcionario} from '../models/interfaces';
import {Tentativa} from '../models/interfaces/tentativa';
import {Justificativa} from '../shared/principal/justificaticas-ezpoint/models/justificativa';
import {catchError, retry} from 'rxjs';
import {throwError} from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root',
})
export class FuncionariosService {
  constructor(private http: HttpClient) {
  }

  BuscarFuncionarios() {
    return this.http.get<Funcionario[]>('api/v1/funcionarios');
  }

  AtualizaStatusFuncionario(func: Funcionario) {
    return this.http.put<Funcionario>(`api/v1/funcionarios`, func);
  }

  forcaSincFuncionarios(): Observable<boolean> {
    return this.http.get<boolean>('api/v1/util/sincFunc');
  }

  LimparFace(func: Funcionario) {
    return this.http.post<boolean>(`api/v1/util/limparface/${func.idd}`, {});
  }

  LimparLogin(func: Funcionario) {
    return this.http.post<boolean>(`api/v1/util/limparLogin/${func.idd}`, {});
  }

  ImportarPorArquivo(funcs: Funcionario[]) {
    return this.http.post<boolean>(`api/v1/util/arquivo`, funcs);
  }

  BuscarTentativas(di: Date, df: Date) {
    return this.http.post<Tentativa[]>(`api/v1/tentativas`, {
      pis: null,
      dataInicial: di,
      dataFinal: df,
    });
  }

  BuscarTentativasPis(pis: number, di: Date, df: Date) {
    return this.http.post<Tentativa[]>(`api/v1/tentativas/pis`, {
      pis: pis,
      dataInicial: di,
      dataFinal: df,
    });
  }

  buscarJustificativas() {
    return this.http.get<Justificativa[]>(`api/v1/justificativas`)
      .pipe(
        retry(1),
        catchError((error: any) => throwError(error))
      );
  }

  buscarJustificativasAjuste() {
    return this.http.get<Justificativa[]>(`api/v1/justificativas/ajustes`)
      .pipe(
        retry(1),
        catchError((error: any) => throwError(error))
      );
  }

  buscarJustificativasFalta() {
    return this.http.get<Justificativa[]>(`api/v1/justificativas/falta`)
      .pipe(
        retry(1),
        catchError((error: any) => throwError(error))
      );
  }

  salvarJustificativa(just: Justificativa) {
    return this.http.post<Justificativa>(`api/v1/justificativas`, just)
      .pipe(
        retry(1),
        catchError((error: any) => throwError(error))
      );
  }

  excluirJustificativa(just: Justificativa) {
    return this.http.delete<Justificativa>(`api/v1/justificativas/${just.idd}`)
      .pipe(
        retry(1),
        catchError((error: any) => throwError(error))
      );
  }
}
